/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useHistory, useLocation } from 'react-router-dom';
import { IFilter } from '../../../interfaces';
import { useDispatch, useSelector } from 'react-redux';

import { fetchListRegions, resetRegion } from '../../../../modules/sport/actions/reducerListRegion';
import { getCommuneByRegions } from '../../../../modules/sport/actions/reducerListCommune';
import { attributesBySport } from '../../../data/attributes';
import { getRankingBysportPaginated } from '../../../../modules/sport/actions/reducerListRanking';
import { getIdSports } from '../../../data/sports';
import Select from 'react-select';
import goToPositions from '../../../components/images/challenges/go-to-challenge.png';
import DesafiaIconsFutbol from '../../../components//images/sports/futbol/icons/desafia2@2x.png';

import Image from '../../../Image';
// Get the current date in format YYYY-mm 2023-04
const getCurrentDate = (): string => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const month = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
    return `${currentYear}-${month}`;
};

const getMonthList = (): { month: string; date: string; type: string }[] => {
    // Create a month and year list for the current year. Must be in the form of {month: 'January', date: '2021-04'}

    const today = new Date();
    const currentYear = today.getFullYear();
    // console.log({ mes: today.getMonth() });
    const filterDateList = [
        { month: 'Verano (Diciembre - Febrero)', date: 'Summer', type: 'season' },
        { month: 'Otoño (Marzo - Mayo)', date: 'Fall', type: 'season' },
        { month: 'Invierno (Junio - Agosto)', date: 'Winter', type: 'season' },
        { month: 'Primavera (Septiembre - Noviembre)', date: 'Spring', type: 'season' },
        { month: 'Ultimos 30 días', date: '30', type: 'days' },
        { month: 'Ultimos 60 días', date: '60', type: 'days' },
        { month: 'Ultimos 90 días', date: '90', type: 'days' },
        { month: 'Ultimos 365 días', date: '365', type: 'days' },
    ]; // Definir filterDateList como un array vacío
    for (let i = 0; i < today.getMonth() + 1; i++) {
        let month = new Date(currentYear, i)
            .toLocaleString('es-CL', { month: 'long', year: 'numeric' })
            .replaceAll('de', ' - ');
        // Capatilize the first letter of the month
        month = month.charAt(0).toUpperCase() + month.slice(1);

        // date must be in this format 2023-04
        const currentMonth = i + 1;
        const monthNumber = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
        const date = `${currentYear}-${monthNumber}`;
        filterDateList.push({ month: month, date: date, type: 'month' });
    }

    // console.log({ filterDateList });
    return filterDateList;
};

function useQuery() {
    return new URLSearchParams(useLocation().search);
}
const styles = {
    valueContainer: (base) => ({
        ...base,
        height: 56,
        borderRadius: 10,
        maxHeight: 54,
        overflowY: 'auto',
        //fontSize: '17px',
    }),
    multiValue: (base, state) => {
        return state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base;
    },
    multiValueLabel: (base, state) => {
        return state.data.isFixed ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 } : base;
    },
    multiValueRemove: (base, state) => {
        return state.data.isFixed ? { ...base, display: 'none' } : base;
    },
};

export default function FilterRanking(): JSX.Element {
    const history = useHistory();

    const [loading, setLoading] = useState<boolean>(false);
    const [communes, setCommune] = useState<Array<any>>([]);
    const errorInit = { region: false, commune: false };
    const [error] = useState(errorInit);
    const query = useQuery();
    const region = query.get('region');
    const commune = query.get('commune');
    const qcommunes = query.get('communes');
    const qMonth = query.get('month');
    const qDays = query.get('days');
    const qSeason = query.get('season');
    const limit = query.get('limit') || 50;
    const page = query.get('page') || 1;
    const months = getMonthList();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const sportId = query.get('sportId') || getIdSports(sport);
    const attributes = attributesBySport('defy');
    const [regions, setRegions] = useState<Array<any>>([]);
    const [typeFilter, setTypeFilter] = useState('month');
    const [filter, setFilter] = useState<IFilter>({
        month:
            qMonth && qMonth !== ''
                ? qMonth
                : qDays && qDays !== ''
                ? qDays
                : qSeason && qSeason !== ''
                ? qSeason
                : qSeason === '' && qDays === ''
                ? getCurrentDate()
                : getCurrentDate(),
        days: qDays && qDays !== '' ? qDays : '',
        season: qSeason && qSeason !== '' ? qSeason : '',
        region: region ?? '',
        commune: commune,
        communes: [],
    });
    const dispatch = useDispatch();

    const selectListRegions = (state: any) => state.listRegions;
    const listRegions = useSelector(selectListRegions);

    const selectListCommunes = (state: any) => state.listCommunes;
    const listCommunes = useSelector(selectListCommunes);

    useEffect(() => {
        dispatch(fetchListRegions({ filter: 1, sport: sport }));
    }, []);

    useEffect(() => {
        if (listRegions.data && listRegions.data.length > 0) {
            setRegions(listRegions.data);
        }
    }, [listRegions]);

    useEffect(() => {
        if (listCommunes && listCommunes.data?.data?.length > 0) {
            //setCommune(listCommunes.data?.data);
            setCommune(listCommunes.data?.data.map((item) => ({ value: item.id, label: item?.name })));
            setFilter({
                ...filter,
                communes: listCommunes.data?.data
                    ?.filter((item) => [filter?.commune].concat(qcommunes?.split(',')).includes(item.id))
                    ?.map((item) => ({ value: item.id, label: item?.name })),
            });
        }
    }, [listCommunes]);

    useEffect(() => {
        setRegions([]);
        setCommune([]);
        dispatch(resetRegion());
        dispatch(fetchListRegions({ filter: 1, sport: sport }));
    }, [sport]);

    const setParams = (name: string, value: string, isDelete: boolean) => {
        // Sets new parameters onto our URLSearchParams object
        isDelete ? query.delete(name) : query.set(name, value);

        // Pushes new parameters onto the current URL using URLSearchParams object toString method
        history.push({
            pathname: location.pathname,
            search: query.toString(),
        });
    };

    useEffect(() => {
        if (region && communes.length === 0) {
            setLoading(true);
            setFilter({ ...filter, region: region });
            dispatch(getCommuneByRegions({ id: region, sport: sport, filter: 1 }));
            setLoading(false);
        }
    }, [region]);

    const handleDays = (e) => {
        e.preventDefault();
        if (e.target.value && months && months.length > 0) {
            // console.log({ months });
            const { type } = months.find((item) => item.date === e.target.value);
            // console.log({ type });
            setTypeFilter(type);
            setParams(type, e.target.value, false);
            if (type === 'days') {
                setParams('month', '', true);
                setParams('season', '', true);
                setFilter({ ...filter, [type]: e.target.value, month: '', season: '' });
            } else if (type === 'month') {
                setParams('days', '', true);
                setParams('season', '', true);
                setFilter({ ...filter, [type]: e.target.value, days: '', season: '' });
            } else if (type === 'season') {
                setParams('days', '', true);
                setParams('month', '', true);
                setFilter({ ...filter, [type]: e.target.value, days: '', month: '' });
            }
        } else {
            setFilter({ ...filter, days: '', month: '', season: '' });
            setParams('days', '', true);
            setParams('month', '', true);
            setParams('season', '', true);
        }
    };

    /* useEffect(() => {
        console.log({ typeFilter });
    }, [typeFilter]);

    useEffect(() => {
        console.log({ months });
    }, [months]);

    useEffect(() => {
        console.log('aqui****', { filter });
    }, [filter]);*/

    const handleRegion = async (e) => {
        e.preventDefault();

        setLoading(true);
        // setRegion(e.target.value);
        setFilter({ ...filter, region: e.target.value });
        dispatch(getCommuneByRegions({ id: e.target.value, sport: sport, filter: 1 }));
        setLoading(false);
        setParams('region', e.target.value, false);
    };

    /*const handleCommune = (e) => {
        e.preventDefault();
        setFilter({ ...filter, commune: e.target.value });
        setParams('commune', e.target.value);
    };*/

    const handleCommune = (e) => {
        //e.preventDefault();
        // console.log('aqui comuna', { e });
        setFilter({ ...filter, communes: e });
        setParams('communes', e?.map((e) => e.value).toString(), false);
    };

    const handleFilter = () => {
        // remove page filter
        // console.log({ filter });
        setParams('page', '', true);
        setLoading(true);
        if (sport && region) {
            const query = {
                sport: sport,
                sportId: sportId,
                regionId: filter.region,
                communes: filter.communes.map((e) => e.value).toString(),
                limit,
                page,
                ...(filter.month !== ''
                    ? { month: filter.month }
                    : filter.days !== ''
                    ? { days: filter.days }
                    : filter.season !== '' && { season: filter.season }),
            };
            // console.log({ query });
            dispatch(getRankingBysportPaginated(query));
        }
        setLoading(false);
    };

    return (
        <div className={`flex-col pt-2 md:pt-16`}>
            <div className={`flex-col flex xl:hidden lg:hidden  justify-center  items-center p-2 md:px-4 `}>
                <div className={`pt-2 md:pt-16  text-center`}>
                    <Image
                        imgClassName={`rounded-3xl ${sport === 'futbol' ? 'pt-4' : 'p-0'}  m-0`}
                        className={``}
                        src={sport === 'futbol' ? DesafiaIconsFutbol : goToPositions}
                        minWidth={null}
                        key={`img-EscudoAzul`}
                        alt="presentation"
                        // width={sport === 'futbol' ? 116 : 120}
                        height={150}
                    />
                </div>
            </div>
            <div className="container snap-mandatory snap-y  mx-auto w-full flex justify-center items-center">
                <div
                    className={`grid w-full grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 text-center justify-center items-center`}
                >
                    <div className="flex-col flex justify-end  items-end p-2 md:px-4  ">
                        <div className="flex w-full md:w-60 lg:w-60 h-14 justify-center content-center">
                            <select
                                className={`${
                                    error.region
                                        ? 'border-red-600 shadow-error'
                                        : filter.region
                                        ? 'border-green-600 shadow-success'
                                        : 'border-sm-gray-3'
                                } w-full md:w-60 lg:w-60 p-2 h-14 bg-white border-2  rounded-xl text-center`}
                                name="region"
                                onChange={handleRegion}
                                value={filter.region ?? ''}
                                disabled={regions && regions.length > 0 ? false : true}
                            >
                                <option className="text-sm-gray-1" value="">
                                    Región *
                                </option>
                                {regions &&
                                    regions.length > 0 &&
                                    regions.map((r, i) => (
                                        <option value={r.id} key={`region-${i}`}>
                                            {r.name}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    </div>
                    <div className="flex-col  flex justify-center  items-center p-2 md:px-4 ">
                        <div className="flex w-full md:w-60 h-14 justify-center content-center ">
                            <div className="w-full  h-14">
                                {/* <select
                                    className={`${
                                        error.commune
                                            ? 'border-red-600 shadow-error'
                                            : filter.commune
                                            ? 'border-green-600 shadow-success'
                                            : 'border-sm-gray-3'
                                    } w-full md:w-60 lg:w-60 p-2 h-14 bg-white border-2  rounded-xl text-center`}
                                    name="commune"
                                    onChange={handleCommune}
                                    disabled={communes && communes.length > 0 ? false : true}
                                    value={filter.commune ?? ''}
                                >
                                    <option className="text-sm-gray-1" value="">
                                        Comuna
                                    </option>
                                    {communes &&
                                        communes.length > 0 &&
                                        communes.map((commune) => (
                                            <option value={commune.id} key={`commune-${commune.id}`}>
                                                {commune.name}
                                            </option>
                                        ))}
                                </select> */}
                                {!loading ? (
                                    <Select
                                        styles={styles}
                                        // styles={{style}}
                                        options={communes || []}
                                        placeholder="Comuna"
                                        value={filter?.communes || []}
                                        onChange={handleCommune}
                                        //className={'h-20'}
                                        isSearchable={true}
                                        isMulti
                                        //hideSelectedOptions={false}
                                        unstyled={false}
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 10,
                                            //fontSize: '13px',
                                            colors: {
                                                ...theme.colors,
                                                text: 'black',
                                                primary25: '#C1FFDA',
                                                primary: '#059669',
                                                primary75: '#C1FFDA',
                                                primary50: '#C1FFDA',
                                            },
                                        })}
                                        /*      menuPlacement="auto"
                                  menuPosition="fixed" */
                                    />
                                ) : (
                                    <div className="border border-sm-rent shadow rounded-xl p-4 max-w-sm w-full mx-auto">
                                        <div className="animate-pulse flex space-x-4">
                                            <div className="rounded-full bg-sm-rent-dark h-6 w-12"></div>
                                            <p className="pl-1 animate-pulse text-sm-rent-dark">Comuna</p>
                                            <div className="flex-1 space-y-4 py-1">
                                                <div className="h-4 bg-sm-rent-dark rounded w-3/4"></div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>{' '}
                        </div>
                    </div>
                    <div className="flex-col   flex justify-start  items-start  p-2 md:px-4 ">
                        <div className="flex w-full md:w-60 h-14  justify-center content-center ">
                            <select
                                className={`${
                                    filter.days ? 'border-green-600 shadow-success' : 'border-sm-gray-3'
                                } w-full md:w-60 lg:w-60 p-2 h-14 bg-white border-2  rounded-xl text-center`}
                                name="day"
                                onChange={handleDays}
                                value={
                                    typeFilter === 'season'
                                        ? filter.season
                                        : typeFilter === 'month'
                                        ? filter.month
                                        : typeFilter === 'days'
                                        ? filter.days
                                        : getCurrentDate()
                                }
                                disabled={months && months.length > 0 ? false : true}
                            >
                                <option className="text-sm-gray-1" value="">
                                    Mes
                                </option>
                                {months &&
                                    months.length > 0 &&
                                    months.map((d) => (
                                        <option value={d.date} key={d.date}>
                                            {d.month}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container snap-mandatory snap-y  mx-auto w-full flex justify-center items-center">
                <div
                    className={`grid w-full grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 text-center justify-center items-center`}
                >
                    <div className={`flex-col snap-end`}> </div>
                    <div className={`flex-col snap-center`}>
                        <div className={`pt-2 md:pt-16  text-center`}>
                            <button
                                className={`${attributes?.filter.btColor} w-1/2 md:w-1/4 lg:w-4/6 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                type="button"
                                onClick={() => handleFilter()}
                            >
                                Buscar
                            </button>
                        </div>
                    </div>
                    <div className={`flex-col xl:flex  lg:flex hidden  justify-center  items-start p-2 md:px-4 `}>
                        <div className={`pt-2 md:pt-16  text-center`}>
                            <Image
                                imgClassName={`rounded-3xl ${sport === 'futbol' ? 'pt-4' : 'p-0'}  m-0`}
                                className={``}
                                src={sport === 'futbol' ? DesafiaIconsFutbol : goToPositions}
                                minWidth={null}
                                key={`img-EscudoAzul`}
                                alt="presentation"
                                //  width={sport === 'futbol' ? 116 : 120}
                                height={150}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
